import { availableStates } from '@/helpers/availableStates'
import getApiClient from '@/plugins/api'
import fileValidator from '@/helpers/fileValidator'
import { VueEditor } from 'vue2-editor'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'PublicAgencyRegistration',
  components: {
    VueEditor,
    Cropper,
    VueRecaptcha,
  },
  data() {
    return {
      availableStates,
      agency: {
        name: '',
        picture: '',
        cover: '',
        about: '',
        description: '',
        cart: false,
        cnpj: '',
        cadastur: '',
        mail: '',
        phone: '',
        password: '',
        city: '',
        state: '',
        pixKey: '',
        fbPageId: '',
      },
      errors: {
        name: null,
        picture: null,
        cover: null,
        about: null,
        description: null,
        cnpj: null,
        cadastur: null,
        mail: null,
        phone: null,
        password: null,
        city: null,
        state: null,
        pixKey: null,
      },
      croppingImage: null,
      showCropper: false,
      croppingModel: null,
      cropperAspectRatio: 16 / 9,
      error: false,
      success: false,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ],
      recaptchaToken: null,
    }
  },
  methods: {
    openCropper(files, model) {
      const image = files[0]

      this.croppingModel = model

      const valid = fileValidator(image, {
        maximumSize: 1024 * 2000
      })

      if (!valid.result) {
        alert(valid.message)
        return
      }

      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.croppingImage = e.target.result
        this.showCropper = true

        if (model === 'picture') {
          this.cropperAspectRatio = 1
        } else if (model === 'cover') {
          this.cropperAspectRatio = 16 / 9
        }
      }
    },

    closeCropper() {
      this.croppingImage = null
      this.showCropper = false
      this.croppingModel = null
    },

    setImage() {
      const { canvas } = this.$refs.imageCropper.getResult()
      const imageData = canvas.toDataURL('image/jpeg', 0.7)

      if (this.croppingModel === 'picture') {
        this.agency.picture = imageData
      } else if (this.croppingModel === 'cover') {
        this.agency.cover = imageData
      }

      this.closeCropper()
    },

    saveAgency() {
      const self = this
      const api = getApiClient(self.$store)

      self.$store.commit('startLoading')
      self.error = false
      self.success = false
      self.resetErrors()

      let payload = { ...self.agency }
      payload.cart = 1
      payload.recaptchaToken = self.recaptchaToken

      api.post('agencies/register', payload)
        .then(() => {
          self.success = true

          window.scrollTo(0, 0)

          setTimeout(() => {
            self.resetForm()
          }, 3000)
        })
        .catch(error => {
          console.error(error)
          if (error.response) {
            switch (error.response.status) {
              case 400:
              case 422:
                self.processValidationErrors(error.response.data)
                break
              case 500:
                self.error = true
                break
            }
          } else {
            self.error = true
          }
          window.scrollTo(0, 0)
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    },

    processValidationErrors(errors) {
      this.$refs['recaptcha'].reset()
      if (errors.violations) {
        errors.violations.forEach((violation) => {
          this.errors[violation.propertyPath] = violation.message
        })
        this.error = true
      }
    },

    resetErrors() {
      this.errors = {
        name: null,
        picture: null,
        cover: null,
        about: null,
        description: null,
        cnpj: null,
        cadastur: null,
        mail: null,
        phone: null,
        password: null,
        city: null,
        state: null,
        pixKey: null,
      }
    },

    resetForm() {
      this.agency = {
        name: '',
        picture: '',
        cover: '',
        about: '',
        description: '',
        cart: false,
        cnpj: '',
        cadastur: '',
        mail: '',
        phone: '',
        password: '',
        city: '',
        state: '',
        pixKey: '',
      }
      this.success = false
      this.error = false
      this.resetErrors()
    },

    onRecaptchaVerify(token) {
      this.recaptchaToken = token
    },

    onRecaptchaExpired() {
      this.recaptchaToken = null
    },
  },
}
